import { Vue, Component, Prop } from 'vue-property-decorator'
import ConfigurationRelationships from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { ConfigurationSectionResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section/configuration-section.dto'
import {
    ConfigurationLocalAssaysSectionsModalAssaysGroupsFormState,
    initialConfigurationLocalAssaysSectionsModalAssaysGroupsFormState
} from '@/modules/configurationModule/detail/local-laboratory-module/sections/components/modal-assays-groups-form/configuration-local-assays-sections-modal-assays-groups-form.model'
import { configurationAssaygroupService } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.service'
import {
    ConfigurationSectionAssayGroupCreateRequest,
    ConfigurationSectionAssayGroupResponse
} from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section-assay-group/configuration-section-assay-group.dto'
import { configurationSectionAssayGroupService } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section-assay-group/configuration-section-assay-group.service'
import { ConfigurationAssaygroupResponse } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationRelationships
    }
})
export default class ConfigurationLocalAssaysSectionsModalAssaysGroupsForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly section!: ConfigurationSectionResponse

    state: ConfigurationLocalAssaysSectionsModalAssaysGroupsFormState
    constructor() {
        super()
        this.state = initialConfigurationLocalAssaysSectionsModalAssaysGroupsFormState()
    }

    private async _loadSectionsAssaysGroups(): Promise<void> {
        this.state.sectionAssaysGroups = await this._getSectionsAssaysGroups()
    }

    async mounted() {
        await this._loadSectionsAssaysGroups()
    }

    /// SERVICES CALLS ///

    async getAssaysGroups(): Promise<ConfigurationAssaygroupResponse[]> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationAssaygroupService.paginator(undefined, params))
        if (response) {
            return response.content
        }
        return []
    }

    private async _createSectionAssayGroup(createRequest: ConfigurationSectionAssayGroupCreateRequest): Promise<ConfigurationSectionAssayGroupResponse | null> {
        const response = await this.$_toCallUnique(configurationSectionAssayGroupService.create(this.state.laboratoryId, createRequest))
        if (response) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.created'))
            return response
        }
        return null
    }

    private async _getSectionsAssaysGroups(): Promise<ConfigurationSectionAssayGroupResponse[]> {
        const filterModel: CommonFilterModel = {
            'section.id': GridUtils.getNumberFilterModel('equals', this.section.id)
        }
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationSectionAssayGroupService.paginator(filterModel, params, this.state.laboratoryId))
        if (response) {
            return response.content
        }
        return []
    }

    private async _deleteSectionAssayGroup(requestDelete: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[] | null> {
        const ids = requestDelete?.entityIdentifiers
        if (ids?.length) {
            const response = await this.$_toCallUnique(configurationSectionAssayGroupService.delete(this.state.laboratoryId, requestDelete))
            if (response) {
                const elements = ids.length - response.length
                if (elements > 0) {
                    this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted'))
                }
                return response
            }
        }
        return null
    }

    /// FORM OPERATIONS ///

    async createOperation(assayGroup: ConfigurationAssaygroupResponse): Promise<void> {
        if (assayGroup) {
            const createRequest: ConfigurationSectionAssayGroupCreateRequest = {
                sectionId: this.section.id,
                assayGroupId: assayGroup.id
            }
            if (await this._createSectionAssayGroup(createRequest)) {
                await this._loadSectionsAssaysGroups()
            }
        }
    }

    async deleteOperation(sectionAssayGroup: ConfigurationSectionAssayGroupResponse): Promise<void> {
        if (sectionAssayGroup) {
            const requestDelete: EntityIdentifiersRequest = {
                entityIdentifiers: [sectionAssayGroup.id]
            }
            if (await this._deleteSectionAssayGroup(requestDelete)) {
                await this._loadSectionsAssaysGroups()
            }
        }
    }
}
